export function applySmoothwallTheme(): void {
	document.title = "Smoothwall";
	let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
	if (!link) {
		link = document.createElement("link");
		link.rel = "icon";
		document.getElementsByTagName("head")[0].appendChild(link);
	}
	link.href = "/static/smoothwallfavicon-16x16.png";
}
